// External imports
import React, { useState, useEffect } from "react";
import { connect } from "react-redux";
import { Modal, Button } from "react-bootstrap";
import { HashRouter as Router, Switch, Route } from "react-router-dom";
import { IoMdDoneAll } from "react-icons/io";
// Local imports
import {
	fetchUsers,
	loginSuccess,
	logoutSuccess,
} from "../src/actions/user/userActions";

import ProtectedRoute from "./components/ProtectedRoute";
import LoginPage from "./pages/auth/LoginPage";
import Menu from "./components/Menu";
import ChangePassword from "./pages/auth/ChangePassword";

import DashboardPage from "./pages/private/dashboard/DashboardPage";
import UsersPage from "./pages/private/UsersPage";
import adduser from "./pages/private/AddUser";
import MyProfile from "./pages/private/MyProfile";

// reports
import InventoryPage from "./pages/private/reports/InventoryPage";

import TaskPage from "./pages/private/task/TaskPage";
import ClientPage from "./pages/private/ClientPage";
// import ProductsPage from './pages/private/reports/ProductsPage'
import ContactsPage from "./pages/private/reports/ContactsPage";
import InvoicesPage from "./pages/private/reports/InvoicePage";
import ShipmentPage from "./pages/private/reports/ShipmentPage";
import GoodsReceiptPage from "./pages/private/reports/GoodsReceiptPage";
import PurchasesPage from "./pages/private/reports/PurchasesPage";
import ProductsPage from "./pages/private/reports/productsPage";
import SalesFeePage from "./pages/private/reports/SalesFeePage";
import ProductCatalouge from "./pages/private/reports/ProductCatalouge";
import OutBoundReports from "./pages/private/reports/OutboundReports";
import SalesSourcePage from "./pages/private/reports/SalesSourcePage";
import OutboundGenentechChargebackPage from "./pages/private/reports/OutboundGenentechChargebackPage";
import OutBoundAptevoServiceFeesPage from "./pages/private/reports/OutBoundAptevoServiceFeesPage";
import OutboundInventoryPage from "./pages/private/reports/OutboundInventoryPage";
import SalesReportSourceDataMonthly from "./pages/private/reports/SalesReportSourceDataMonthly";
import AptevoSalesSourcePage from "./pages/private/reports/AptevoSalesSourcePage";
import SalesOrderPage from "./pages/private/reports/SalesOrderPage";
// import InvoiceReports from './pages/private/reports/PDFReports/InvoiceReports'
import AptevoInventorySourcePage from "./pages/private/reports/AptevoInventorySourcePage";
import OctapharmaEndOfMonthInventorySourcePage from "./pages/private/reports/OctapharmaEndOfMonthInventorySourcePage";
import AptevoQuarterlyServiceFeesPage from "./pages/private/reports/AptevoQuarterlyServiceFeesPage";
import AllianceSalesReportSourceDatamonthly from "./pages/private/reports/AllianceSalesReportSourceDatamonthly";
import OctapharmaChargebacksSourceDatamonthly from "./pages/private/reports/OctapharmaChargebacksSourceDatamonthly";
import AptevoChargebacksSourceMapmonthly from "./pages/private/reports/AptevoChargebacksSourceMapmonthly";
import AkronServiceFeesInvoiceReports from "./pages/private/reports/PDFReports/AkronServiceFeesInvoiceReports";
import AptevoChargebackInvoiceReports from "./pages/private/reports/PDFReports/AptevoChargebackInvoiceReports";
import AptevoServiceFeesInvoiceReports from "./pages/private/reports/PDFReports/AptevoServiceFeesInvoiceReports";
import OctapharmaInvoiceReports from "./pages/private/reports/PDFReports/OctapharmaInvoiceReports";
import TrackTrace from "./pages/private/reports/TrackTrace/TrackTrace";
import axios from "axios";
import { useHistory } from "react-router";
import OctapharmaAdminFeesSourceDataMonthly from "./pages/private/reports/OctapharmaAdminFeesSourceDataMonthly";
import DataSync from "./pages/private/dataSync/DataSync";
import AptevoChargebacks from "./pages/private/reports/EDIReports/AptevoChargebacks";
import OctapharmaChargebacks from "./pages/private/reports/EDIReports/OctapharmaChargebacks";
import GenentechChargebacks from "./pages/private/reports/EDIReports/GenentechChargebacks";
import GenentechProductTransfer from "./pages/private/reports/EDIReports/GenentechProductTransfer";
import AkornAdvanceShipNotice from "./pages/private/reports/EDIReports/AkornAdvanceShipNotice";
import OctapharmaAdvanceShipNotice from "./pages/private/reports/EDIReports/OctapharmaAdvanceShipNotice";
import GenentechAdvanceShipNotice from "./pages/private/reports/EDIReports/GenentechAdvanceShipNotice";
import AptevoAdvanceShipNotice from "./pages/private/reports/EDIReports/AptevoAdvanceShipNotice";
import AllianceAdvanceShipNotice from "./pages/private/reports/EDIReports/AllianceAdvanceShipNotice";
import AkornProductTransfer from "./pages/private/reports/EDIReports/AkornProductTransfer";
import OctaPharmaProductTransfer from "./pages/private/reports/EDIReports/OctaPharmaProductTransfer";
import AllianceProductTransfer from "./pages/private/reports/EDIReports/AllianceProductTransfer";
import AptevoProductTransfer from "./pages/private/reports/EDIReports/AptevoProductTransfer";
import AkornServiceFees from "./pages/private/reports/EDIReports/AkornServiceFees";
import OctapharmaSales from "./pages/private/reports/EDIReports/OctapharmaSales";
import GenentechSales from "./pages/private/reports/EDIReports/GenentechSales";
import AllianceSales from "./pages/private/reports/EDIReports/AllianceSales";
import AptevoSales from "./pages/private/reports/EDIReports/AptevoSales";
import InventoryEDI from "./pages/private/reports/EDIReports/InventoryEDI";
import Holidays from "./pages/private/Holidays/Holidays";
import AddHolidays from "./pages/private/Holidays/AddHoliday";
import PriceUpdate from "./pages/private/FileImports/PriceUpdate";
import FileImports from "./pages/private/FileImports/FileImports";
import InventoryAddEdit from "./pages/private/reports/EDIReports/InventoryAddEdit";
import ChargebackAddEdit from "./pages/private/reports/EDIReports/ChargebackAddEdit";
import ProductTransferAddEdit from "./pages/private/reports/EDIReports/ProductTransferAddEdit";
import OctapharmaChargebacksEdit from "./pages/private/reports/EditReports/OctapharmaChargebacksEdit";
import AptevoChargebacksEdit from "./pages/private/reports/EditReports/AptevoChargebacksEdit";
import GenentechChargebacksEdit from "./pages/private/reports/EditReports/GenentechChargebacksEdit";
import AptevoInventoryEdit from "./pages/private/reports/EditReports/AptevoInventoryEdit";
import OctapharmaInventoryEdit from "./pages/private/reports/EditReports/OctapharmaInventoryEdit";
import GenentechInventoryEdit from "./pages/private/reports/EditReports/GenentechInventoryEdit";
import AkornServiceFeeEdit from "./pages/private/reports/EditReports/AkornServiceFeeEdit";
import AptevoSalesEdit from "./pages/private/reports/EditReports/AptevoSalesEdit";
import AllianceSalesEdit from "./pages/private/reports/EditReports/AllianceSalesEdit";
import GenentechSalesEdit from "./pages/private/reports/EditReports/GenentechSalesEdit";
import OctapharmaSalesEdit from "./pages/private/reports/EditReports/OctapharmaSalesEdit";
import AptevoQuarterlyServiceFeesEdit from "./pages/private/reports/EditReports/AptevoQuarterlyServiceFeesEdit";
import OctapharmaAdminFeesEdit from "./pages/private/reports/EditReports/OctapharmaAdminFeesEdit";

import SalesEdiAddEdit from "./pages/private/reports/EDIReports/SalesEdiAddEdit";
import AdvanceShipEdiAddEdit from "./pages/private/reports/EDIReports/AdvanceShipEdiAddEdit";
import AkornChargebacks from "./pages/private/reports/EDIReports/AkornChargebacks";

const App = ({ dispatch, login, hideSideMenuProp }) => {
	//
	const history = useHistory();
	const [sessionExpiry, setSessionExpiry] = useState(false);
	// Add a response interceptor
	axios.interceptors.response.use(
		function (response) {
			return response;
		},
		function (error) {
			//catches if the session ended!
			if (
				error.response.status === 400 &&
				(error.response.data.Message ===
					"Web Helper Exception : Session expired or invalid user request" ||
					error.response.data.Message ===
						"Web Helper Exception : Invalid web request. Application Security Code is not found or Intrusion detected. ")
			) {
				setSessionExpiry(true);
				localStorage.clear();
				localStorage.removeItem("userData");
				localStorage.removeItem("products");
				localStorage.removeItem("contacts");
				localStorage.removeItem("barColors");
				localStorage.removeItem("barLabels");
				localStorage.removeItem("clients");
				localStorage.removeItem("dataSync");
				localStorage.removeItem("Invoices");
				localStorage.removeItem("Purchases");
				localStorage.removeItem("loggedIn");
			}
			return Promise.reject(error);
		}
	);

	useEffect(() => {
		dispatch(fetchUsers());
		if (localStorage.getItem("loggedIn")) {
			dispatch(loginSuccess());
		}
		setTimeout(() => {
			localStorage.removeItem("Invoices");
			localStorage.removeItem("Purchases");
		}, 15 * 60000);
		setInterval(() => {
			localStorage.removeItem("products");
			localStorage.removeItem("contacts");
			localStorage.removeItem("barColors");
			localStorage.removeItem("barLabels");
			localStorage.removeItem("clients");
			localStorage.removeItem("dataSync");
		}, 3 * 60000);
	}, [dispatch]);

	const logoutHandle = () => {
		setSessionExpiry(false);
		localStorage.clear();
		localStorage.removeItem("userData");
		localStorage.removeItem("products");
		localStorage.removeItem("contacts");
		localStorage.removeItem("barColors");
		localStorage.removeItem("barLabels");
		localStorage.removeItem("clients");
		localStorage.removeItem("dataSync");
		localStorage.removeItem("Invoices");
		localStorage.removeItem("Purchases");
		localStorage.removeItem("loggedIn");
		window.location.reload();
	};

	return (
		<div className={hideSideMenuProp ? "app-wrapper minimize" : "app-wrapper"}>
			{/* <TokenImpl/> */}
			<Router>
				{login ? (
					<Menu
						sessionExpiry={sessionExpiry}
						setSessionExpiry={setSessionExpiry}
					/>
				) : null}
				<Switch>
					<Route exact path="/" component={LoginPage} />
					<ProtectedRoute
						exact
						path="/change-password"
						component={ChangePassword}
					/>
					<ProtectedRoute
						exact
						path="/dashboard"
						component={DashboardPage}
						login={login}
					/>
					<ProtectedRoute exact path="/users" component={UsersPage} />
					<ProtectedRoute
						exact
						path="/inventory-transaction"
						component={InventoryPage}
					/>
					<ProtectedRoute exact path="/invoices" component={InvoicesPage} />
					<ProtectedRoute exact path="/shipments" component={ShipmentPage} />
					<ProtectedRoute exact path="/products" component={ProductsPage} />
					<ProtectedRoute exact path="/task" component={TaskPage} />
					<Route exact path="/task/:id/edit" component={TaskPage} />
					<Route exact path="/task/:id/view" component={TaskPage} />

					<ProtectedRoute exact path="/client" component={ClientPage} />
					<ProtectedRoute exact path="/adduser" component={adduser} />
					<ProtectedRoute exact path="/my-profile" component={MyProfile} />
					<ProtectedRoute exact path="/contacts" component={ContactsPage} />
					<ProtectedRoute
						exact
						path="/goods-receipts"
						component={GoodsReceiptPage}
					/>
					<ProtectedRoute
						exact
						path="/purchase-order"
						component={PurchasesPage}
					/>
					<ProtectedRoute exact path="/salesorder" component={SalesOrderPage} />
					<ProtectedRoute exact path="/sales-fee" component={SalesFeePage} />
					<ProtectedRoute exact path="/catalog" component={ProductCatalouge} />
					<ProtectedRoute
						exact
						path="/outbound-reports"
						component={OutBoundReports}
					/>
					<ProtectedRoute
						exact
						path="/sales-source"
						component={SalesSourcePage}
					/>
					<ProtectedRoute
						exact
						path="/chargeback"
						component={OutboundGenentechChargebackPage}
					/>
					<ProtectedRoute
						exact
						path="/service-fee"
						component={OutBoundAptevoServiceFeesPage}
					/>
					<ProtectedRoute
						exact
						path="/outbound-inventory"
						component={OutboundInventoryPage}
					/>
					<ProtectedRoute
						exact
						path="/salesReportSourceDataMonthly"
						component={SalesReportSourceDataMonthly}
					/>
					<ProtectedRoute
						exact
						path="/aptevoSalesSource"
						component={AptevoSalesSourcePage}
					/>
					{/* <ProtectedRoute exact path="/invoiceReports/:id" component={InvoiceReports}/> */}
					<ProtectedRoute
						exact
						path="/aptevoInventorySource"
						component={AptevoInventorySourcePage}
					/>
					<ProtectedRoute
						exact
						path="/allianceSalesReportSourceData"
						component={AllianceSalesReportSourceDatamonthly}
					/>
					<ProtectedRoute
						exact
						path="/octapharmaChargebacksSourceDatamonthly"
						component={OctapharmaChargebacksSourceDatamonthly}
					/>

					<ProtectedRoute
						exact
						path="/octapharmaEndOfMonthInventorySource"
						component={OctapharmaEndOfMonthInventorySourcePage}
					/>
					<ProtectedRoute
						exact
						path="/aptevoQuarterlyServiceFees"
						component={AptevoQuarterlyServiceFeesPage}
					/>
					<ProtectedRoute
						exact
						path="/aptevoChargebacksSourceMap"
						component={AptevoChargebacksSourceMapmonthly}
					/>
					<ProtectedRoute
						exact
						path="/octapharmaAdminFeesSource"
						component={OctapharmaAdminFeesSourceDataMonthly}
					/>

					<ProtectedRoute
						exact
						path="/akronServiceFeesInvoiceReports/:id"
						component={AkronServiceFeesInvoiceReports}
					/>
					<ProtectedRoute
						exact
						path="/aptevoChargebackInvoiceReports/:id"
						component={AptevoChargebackInvoiceReports}
					/>
					<ProtectedRoute
						exact
						path="/aptevoServiceFeesInvoiceReports/:id"
						component={AptevoServiceFeesInvoiceReports}
					/>
					<ProtectedRoute
						exact
						path="/octapharmaInvoiceReports/:id"
						component={OctapharmaInvoiceReports}
					/>
					<ProtectedRoute
						exact
						path="/track-and-trace"
						component={TrackTrace}
					/>
					<ProtectedRoute exact path="/dataSync" component={DataSync} />

					<ProtectedRoute
						exact
						path="/aptevoChargebacksEDI"
						component={AptevoChargebacks}
					/>
					<ProtectedRoute
						exact
						path="/octapharmaChargebacksEDI"
						component={OctapharmaChargebacks}
					/>
					<ProtectedRoute
						exact
						path="/genentechChargebacksEDI"
						component={GenentechChargebacks}
					/>
					<ProtectedRoute
						exact
						path="/akornChargebacksEDI"
						component={AkornChargebacks}
					/>
					<ProtectedRoute
						exact
						path="/genentechProductTransferEDI"
						component={GenentechProductTransfer}
					/>
					<ProtectedRoute
						exact
						path="/akornProductTransferEDI"
						component={AkornProductTransfer}
					/>
					<ProtectedRoute
						exact
						path="/octaPharmaProductTransferEDI"
						component={OctaPharmaProductTransfer}
					/>
					<ProtectedRoute
						exact
						path="/allianceProductTransferEDI"
						component={AllianceProductTransfer}
					/>
					<ProtectedRoute
						exact
						path="/aptevoProductTransferEDI"
						component={AptevoProductTransfer}
					/>

					<ProtectedRoute
						exact
						path="/akornServiceFeesEDI"
						component={AkornServiceFees}
					/>
					<ProtectedRoute
						exact
						path="/octapharmaSalesEDI"
						component={OctapharmaSales}
					/>
					<ProtectedRoute
						exact
						path="/genentechSalesEDI"
						component={GenentechSales}
					/>
					<ProtectedRoute
						exact
						path="/allianceSalesEDI"
						component={AllianceSales}
					/>
					<ProtectedRoute
						exact
						path="/aptevoSalesEDI"
						component={AptevoSales}
					/>

					<ProtectedRoute exact path="/InventoryEDI" component={InventoryEDI} />

					<ProtectedRoute
						exact
						path="/akornAdvanceShipNoticeEDI"
						component={AkornAdvanceShipNotice}
					/>
					<ProtectedRoute
						exact
						path="/octapharmaAdvanceShipNoticeEDI"
						component={OctapharmaAdvanceShipNotice}
					/>
					<ProtectedRoute
						exact
						path="/genentechAdvanceShipNoticeEDI"
						component={GenentechAdvanceShipNotice}
					/>
					<ProtectedRoute
						exact
						path="/aptevoAdvanceShipNoticeEDI"
						component={AptevoAdvanceShipNotice}
					/>
					<ProtectedRoute
						exact
						path="/allianceAdvanceShipNoticeEDI"
						component={AllianceAdvanceShipNotice}
					/>
					<ProtectedRoute exact path="/holidays" component={Holidays} />
					<ProtectedRoute exact path="/addHoliday" component={AddHolidays} />
					<ProtectedRoute exacct path="/price_update" component={PriceUpdate} />
					<ProtectedRoute exacct path="/file_imports" component={FileImports} />
					<ProtectedRoute
						exacct
						path="/InventoryAddEdit"
						component={InventoryAddEdit}
					/>
					<ProtectedRoute
						exacct
						path="/ChargebackAddEdit"
						component={ChargebackAddEdit}
					/>
					<ProtectedRoute
						exacct
						path="/ProductTransferAddEdit"
						component={ProductTransferAddEdit}
					/>
					{/* edit excel */}
					<ProtectedRoute
						exacct
						path="/OctapharmaChargebacksEdit"
						component={OctapharmaChargebacksEdit}
					/>
					<ProtectedRoute
						exacct
						path="/AptevoChargebacksEdit"
						component={AptevoChargebacksEdit}
					/>
					<ProtectedRoute
						exacct
						path="/GenentechChargebacksEdit"
						component={GenentechChargebacksEdit}
					/>
					<ProtectedRoute
						exacct
						path="/AptevoInventoryEdit"
						component={AptevoInventoryEdit}
					/>
					<ProtectedRoute
						exacct
						path="/OctapharmaInventoryEdit"
						component={OctapharmaInventoryEdit}
					/>
					<ProtectedRoute
						exacct
						path="/GenentechInventoryEdit"
						component={GenentechInventoryEdit}
					/>
					<ProtectedRoute
						exacct
						path="/AkornServiceFeeEdit"
						component={AkornServiceFeeEdit}
					/>
					<ProtectedRoute
						exacct
						path="/AptevoSalesEdit"
						component={AptevoSalesEdit}
					/>
					<ProtectedRoute
						exacct
						path="/AllianceSalesEdit"
						component={AllianceSalesEdit}
					/>
					<ProtectedRoute
						exacct
						path="/GenentechSalesEdit"
						component={GenentechSalesEdit}
					/>
					<ProtectedRoute
						exacct
						path="/OctapharmaSalesEdit"
						component={OctapharmaSalesEdit}
					/>
					<ProtectedRoute
						exacct
						path="/AptevoQuarterlyServiceFeesEdit"
						component={AptevoQuarterlyServiceFeesEdit}
					/>
					<ProtectedRoute
						exacct
						path="/OctapharmaAdminFeesEdit"
						component={OctapharmaAdminFeesEdit}
					/>

					<ProtectedRoute
						exacct
						path="/SalesEdiAddEdit"
						component={SalesEdiAddEdit}
					/>
					<ProtectedRoute
						exacct
						path="/AdvanceShipEdiAddEdit"
						component={AdvanceShipEdiAddEdit}
					/>
				</Switch>
			</Router>

			{/* modal */}
			<Modal show={sessionExpiry} backdrop="static" keyboard={false}>
				<Modal.Header>
					<Modal.Title>
						<span className="black-color">Session Expired</span>
					</Modal.Title>
				</Modal.Header>

				<Modal.Body>
					<p className="black-color">
						<strong>
							Your current session has expired or got invalidated. Please login
							again to continue your work.
						</strong>
					</p>
				</Modal.Body>
				<Modal.Footer>
					<div className="text-right mt-2">
						<Button onClick={() => logoutHandle()}>
							<IoMdDoneAll className="icon btn-icon" />
							Ok
						</Button>
					</div>
				</Modal.Footer>
			</Modal>
		</div>
	);
};

// Map Redux state to React component props
const mapStateToProps = (state) => ({
	login: state.users.login,
	hideSideMenuProp: state.uiActions.hideSideMenu,
});

// Connect Redux to React
export default connect(mapStateToProps)(App);
